module.exports = __webpack_public_path__ + "img/w3_viewed_dark.3f1a0b57.png";